import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// styles
import { Header, MainContainer, SubHeader } from './styles';
import { CloseIcon, NavTitle, RightNavContainer, SideBarContent } from 'Layouts/ProjectLayout/styles';
import X from 'Components/Icons/X';

// Components
import Loader from 'Components/Loader';
import DocumentCard from 'Components/DocumentCard';
import OrgIntegrationsSidebarContent from 'Components/OrgIntegrationsSidebarContent';

// Redux
import { apiGetCommsRequest, resetChannelInitialState } from 'Redux/actions/channel';

// Config
import { OrgIntegrationPageSideNavType, OrgIntegrations } from 'Config/integrationsConstant';

const OrgIntegrationsPage = ({ auth, selectedOrgId }) => {
	const channelState = useSelector(state => state.channel);
	const dispatch = useDispatch();

	// useState
	const [showRightNav, setShowRightNav] = useState(false);
	const [sideNavPage, setSideNavPage] = useState(null);
	const [integrationsArr, setIntegrationsArr] = useState(Object.values(OrgIntegrations)); // database saved org integrations and include default integrations
	const [selectedIntegrationData, setSelectedIntegrationData] = useState(null);
	const [isEdit, setIsEdit] = useState(false);

	const onRightNavClose = () => {
		setShowRightNav(false);
		setSelectedIntegrationData(null);
		setIsEdit(false);
	};

	const updateSelectedIntegrationData = (updateData) => {
		setSelectedIntegrationData(updateData);
	};

	const onEditBtnClick = (index) => {
		if (integrationsArr[index].id) { // id exists means that it is fetched from database
			setSideNavPage('EDIT_INTEGRATION');
			setIsEdit(true);
		} else {
			setSideNavPage('ADD_INTEGRATION');
			setIsEdit(false);
		}
		setSelectedIntegrationData(integrationsArr[index]);
		setShowRightNav(true);
	};

	useEffect(() => {
		dispatch(apiGetCommsRequest(null, auth.token, true, selectedOrgId));
		return () => {
			dispatch(resetChannelInitialState());
		};
	}, [selectedOrgId]);

	useEffect(() => {
		if (channelState?.projectComms?.length > 0) {
			const newIntegrationsArr = [...integrationsArr];
			channelState?.projectComms.forEach(item => {
				const idx = integrationsArr.findIndex(integration => integration.type === item.type);
				if (idx !== -1) {
					newIntegrationsArr[idx].title = item?.title;
					newIntegrationsArr[idx].url = item?.url ?? "";
					newIntegrationsArr[idx].id = item?.id ?? null;
					newIntegrationsArr[idx].is_copy_to_projects = item?.is_copy_to_projects ?? false;
				}
			});
			setIntegrationsArr(newIntegrationsArr);
		}
	}, [channelState?.projectComms]);

	return channelState?.isLoading ? (
		<Loader />
	) : (
		<MainContainer>
			<Header>Integrations and connected apps</Header>
			<br />
			<SubHeader>
				Supercharge your workflow and connect the tool you use every day.
			</SubHeader>
			<div className="row" style={{ marginTop: '48px' }}>
				{integrationsArr?.length > 0 && integrationsArr.map((integration, index) => (
					<div
						className="col-lg-6 col-xl-4"
						style={{ marginBottom: '12px' }}
						key={index}
					>
						<DocumentCard
							btnTitle={'Open'}
							image={integration?.image}
							title={integration?.title}
							description={integration?.description}

							url={integration.url}
							subTitle={integration.name}
							editAction={
								<button
									className="btn btn-link text-decoration-none"
									onClick={() => {onEditBtnClick(index)}}
									rel="noopener noreferrer"
								>
									Edit
								</button>
							}
						/>
					</div>
				))}
			</div>
			{showRightNav && (
				<RightNavContainer style={{ position: 'fixed', top: '0', right: '0' }}>
					<CloseIcon onClick={onRightNavClose}>
						<X />
					</CloseIcon>

					<NavTitle>
						{OrgIntegrationPageSideNavType[sideNavPage]?.title}
						<br />
						<span>{OrgIntegrationPageSideNavType[sideNavPage]?.subTitle}</span>
					</NavTitle>

					<SideBarContent>
						<OrgIntegrationsSidebarContent
							onRightNavClose={onRightNavClose}
							selectedOrgId={selectedOrgId}
							selectedIntegrationData={selectedIntegrationData}
							updateSelectedIntegrationData={updateSelectedIntegrationData}
							isEdit={isEdit}
						/>
					</SideBarContent>
				</RightNavContainer>
			)}
		</MainContainer>
	);
};

export default OrgIntegrationsPage;
